import { useContext } from 'react';
import { Text, View } from 'react-native';
import { Icon } from 'react-native-elements';
import OrderContext from 'contexts/OrderContext';
import { styles } from 'styles/components/productItem';
import { greenColor } from 'styles/global';
import ProductType from 'types/enums/ProductType';
import Venue from 'types/models/Venue';
import DetailItem from 'types/models/DetailItem';

interface GuarnicionExtraItemProps {
  currentVenue: Venue | null;
  productId: string;
  isFromDetail?: boolean;
  selectedGuanicionesAndExtrasFromDetail?: DetailItem[];
  onRemoveGuarnicionExtra?: (guarnicionExtraDetail: DetailItem, mainProductId: string) => void;
}

function GuarnicionExtraItem({
  currentVenue,
  productId,
  isFromDetail,
  selectedGuanicionesAndExtrasFromDetail = [],
  onRemoveGuarnicionExtra,
}: GuarnicionExtraItemProps) {
  const { currentShoppingCart } = useContext(OrderContext);

  const filteredItems = isFromDetail
    ? selectedGuanicionesAndExtrasFromDetail
    : currentShoppingCart?.detail.filter(
        (item) =>
          (item.product.typeId === ProductType.Extra && item.relatedProducts?.some((el) => el.id === productId)) ||
          (item.product.typeId === ProductType.Guarnicion && item.relatedProducts?.some((el) => el.id === productId)),
      );

  if (!filteredItems?.length) return null;

  return (
    <>
      {filteredItems.map((item) => (
        <View
          key={`${item.product.id}-${item.quantity}`}
          style={[styles.priceQuantityContainer, { alignItems: 'center' }]}
        >
          <View style={styles.priceContainer}>
            <Text style={[styles.priceText, { color: currentVenue?.appColor }]}>
              {item.product.name} (${Math.floor(item.product.price)})
            </Text>
          </View>

          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Text>({item.relatedProducts?.find((el) => el.id === productId)?.quantity})</Text>
            <Icon
              onPress={() => {
                onRemoveGuarnicionExtra?.(item, productId);
              }}
              name={
                item.relatedProducts?.find((el) => el.id === productId)?.quantity === 1
                  ? 'delete-outline'
                  : 'remove-circle-outline'
              }
              color={currentVenue?.appColor ?? greenColor}
              size={22}
            />
          </View>
        </View>
      ))}
    </>
  );
}

export default GuarnicionExtraItem;
